import { render, staticRenderFns } from "./gj-switch.vue?vue&type=template&id=72e4b922&scoped=true&"
import script from "./gj-switch.vue?vue&type=script&lang=js&"
export * from "./gj-switch.vue?vue&type=script&lang=js&"
import style0 from "./gj-switch.vue?vue&type=style&index=0&id=72e4b922&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e4b922",
  null
  
)

export default component.exports